<div class="row">
    <div [ngClass]="questionCss">
        <app-question [question]="questions.termCode" (controlValueChange)="onChange($event)"></app-question>
    </div>
    <div *ngIf="includeSectionsQuestion" [ngClass]="questionCss">
        <app-question [question]="questions.section" (controlValueChange)="onSectionChange($event)"></app-question>
    </div>
</div>

